export default __webpack_public_path__ + "static/stealth-e381e7ca1145753bcecac1fa878d05b9.jpg";